import React from 'react';

import AutenticacaoService from '../../services/AutenticacaoService';
import AutenticacaoContext from './AutenticacaoContext';

class AutenticacaoProvider extends React.Component {
    autenticacaoService;

    constructor(props) {
        super(props);
        this.autenticacaoService = new AutenticacaoService();
    }

    render() {
        return (
            <AutenticacaoContext.Provider value={this.autenticacaoService}>
                {this.props.children}
            </AutenticacaoContext.Provider>
        );
    }
}

export default AutenticacaoProvider;